export default __webpack_public_path__ + "static/media/fares.3a502437.png";